import { render, staticRenderFns } from "./create-issue.vue?vue&type=template&id=3bccebba&scoped=true&"
import script from "./create-issue.vue?vue&type=script&lang=js&"
export * from "./create-issue.vue?vue&type=script&lang=js&"
import style0 from "./create-issue.vue?vue&type=style&index=0&id=3bccebba&prod&lang=scss&"
import style1 from "./create-issue.vue?vue&type=style&index=1&id=3bccebba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bccebba",
  null
  
)

export default component.exports